import { n as p, r as f, E as y, e as R, b as S, x as a, T as k, a as A } from "./abstract-base-CzLmw6_x.js";
import { e as I } from "./query-DolxHPXs.js";
import { K as B } from "./keys-C6v8knyZ.js";
import { O as T } from "./orientations-CF7v1a0i.js";
import { a as P, p as x, d as N, m as D } from "./lifecycle-decorators-CUsT9aHq.js";
import { a as $, b as z } from "./query-assigned-K46zQIzj.js";
import { d as E } from "./utils-BSj5iT7c.js";
var h = /* @__PURE__ */ ((t) => (t.CLICK = "click", t.HOVER = "hover", t.MANUAL = "manual", t))(h || {}), l = /* @__PURE__ */ ((t) => (t.START = "start", t.CENTER = "center", t.END = "end", t))(l || {}), K = /* @__PURE__ */ ((t) => (t.HORIZONTAL = "horizontal", t.VERTICAL = "vertical", t))(K || {}), n = /* @__PURE__ */ ((t) => (t.BlockStart = "block-start", t.InlineStart = "inline-start", t.BlockEnd = "block-end", t.InlineEnd = "inline-end", t))(n || {});
function j(t, c) {
  return t.has(c) && typeof t.get(c) < "u";
}
var W = Object.defineProperty, H = Object.getOwnPropertyDescriptor, s = (t, c, u, i) => {
  for (var o = i > 1 ? void 0 : i ? H(c, u) : c, e = t.length - 1, r; e >= 0; e--)
    (r = t[e]) && (o = (i ? r(c, u, o) : r(o)) || o);
  return i && o && W(c, u, o), o;
};
const U = (t) => function(u) {
  let i = class extends u {
    constructor() {
      super(...arguments), this.orientation = T.VERTICAL, this.trigger = h.HOVER, this.isOpen = !1, this.content = "", this.alignment = l.CENTER, this.direction = n.InlineStart, this.topOffset = 0, this.leftOffset = 0, this.RTL = !1, this.marginAdjust = 0, this.targetSelectorString = ".overlay-target", this.debouncedCalculateOffset = E(this.calculateOffset.bind(this), 100), this.toggleClick = (e) => {
        e && e.isTrusted && (this.isOpen ? this.close() : this.open());
      }, this.intersectionObserver = new IntersectionObserver(this.debouncedCalculateOffset, { threshold: 1 }), this.resizeObserver = new ResizeObserver(this.debouncedCalculateOffset), this.open = t && !t.disableDebounceOpen ? E(async () => {
        this.calculateOffset(), this.isOpen = !0, this.showTooltip(), await this.updateComplete, this.emitOpen();
      }, 100) : async () => {
        this.calculateOffset(), this.isOpen = !0, this.showTooltip(), await this.updateComplete, this.emitOpen();
      }, this.handleKeydown = (e) => {
        e.isTrusted && this.isOpen && (super.handleKeydown(), this.closeOnEscape(e));
      }, this.handleExternalClick = (e) => {
        e.isTrusted && !e.composedPath().includes(this.overlayEl) && this.isOpen && this.close();
      };
    }
    get targetSelector() {
      return this.targetSelectorString;
    }
    set targetSelector(e) {
      this.targetSelectorString = e;
    }
    get viewportRect() {
      var e;
      return (e = this.viewportRectObj) != null ? e : document.documentElement.getBoundingClientRect();
    }
    set viewportRect(e) {
      this.viewportRectObj = e;
    }
    set targetRect(e) {
      this.targetRectObj = e;
    }
    get scrollListeningContainer() {
      var e;
      return (e = this.scrollListeningContainerObj) != null ? e : window;
    }
    set scrollListeningContainer(e) {
      this.scrollListeningContainerObj = e;
    }
    get overlaySelector() {
      return ".overlay-wrapper";
    }
    get overlayName() {
      return "overlay";
    }
    get externalClickNode() {
      return this.getRootNode();
    }
    static get overlayStyles() {
      return [];
    }
    /**
     * Calculates margin adjustment for when the overlay component is visible
     * @param marginToken token representing the margin of the overlay component
     * @param arrowSizeToken token representing the size of the arrow on the overlay
     */
    computeMarginAdjustment(e, r) {
      this.marginAdjust = parseInt(e, 10) + parseInt(r, 10) / 2;
    }
    /**
     * Evaluate Alignment and Direction based on the Target and Overlay DOMRect.
     * @param target DOMRect of the target element
     * @param overlay DOMRect of the overlay element
     */
    computeDirection(e, r) {
      this.orientation === T.VERTICAL ? (e.y < this.viewportRect.height / 4 ? this.direction = n.BlockStart : this.direction = n.BlockEnd, e.x < this.viewportRect.width / 4 ? this.alignment = l.START : e.x > this.viewportRect.width * 3 / 4 ? this.alignment = l.END : this.alignment = l.CENTER) : (this.alignment = l.CENTER, this.RTL ? this.viewportRect.width < e.x ? this.direction = n.InlineEnd : this.direction = n.InlineStart : e.x + e.width + r.width < this.viewportRect.width ? this.direction = n.InlineStart : this.direction = n.InlineEnd);
    }
    /**
     * @param overlayWidth Width of the Overlay element
     * @param targetWidth Width of the Target Element
     * @returns Based on Alignment, will return leftOffset as number.
     */
    calculateHorizontalOffset(e, r) {
      const d = r - e, v = e / 2 - this.marginAdjust;
      switch (this.alignment) {
        case l.START:
          return d / 2 + v;
        case l.CENTER:
          return d / 2;
        case l.END:
          return d / 2 - v;
        default:
          return 0;
      }
    }
    /**
     * Evaluate the Overlay Leftoffset and topOffset based on targetSelector and Overlay Selector.
     * @abstract
     */
    calculateOffset() {
      var d, v, b;
      const e = (d = this.shadowRoot) == null ? void 0 : d.querySelector(this.targetSelector), r = (v = this.shadowRoot) == null ? void 0 : v.querySelector(this.overlaySelector);
      if (r && (e || this.targetRectObj)) {
        const w = (b = this.targetRectObj) != null ? b : e == null ? void 0 : e.getBoundingClientRect(), L = r.getBoundingClientRect();
        this.computeDirection(w, L);
        const { height: g, width: m } = w, { height: O, width: C } = L;
        switch (this.topOffset = 0, this.leftOffset = m, this.direction) {
          case n.BlockEnd:
            this.topOffset = -1 * (g + O), this.leftOffset = this.calculateHorizontalOffset(C, m);
            break;
          case n.BlockStart:
            this.leftOffset = this.calculateHorizontalOffset(C, m);
            break;
          case n.InlineEnd:
            this.leftOffset = -1 * C, this.topOffset = -1 * (O + (g - O) / 2);
            break;
          case n.InlineStart:
            this.topOffset = -1 * (O + (g - O) / 2);
            break;
        }
      }
    }
    /**
     * Enables overlay surface to reposition and reorient based on:
     * 1. When overlayWrapper is intersecting with viewport border
     * 2. When document body is resized
     * 3. When user scrolls
     */
    engageDynamicOverlayPositioning() {
      this.intersectionObserver.observe(this.overlayWrapper), this.resizeObserver.observe(document.body), this.scrollListeningContainer.addEventListener("scroll", this.debouncedCalculateOffset);
    }
    /**
     * Disengages dynamic overlay positioning by unobserving by:
     * 1. Unobserving overlayWrapper intersections with viewport
     * 2. Unobserving resize of the document body
     * 3. Removing scroll event listener from scrollListeningContainer
     */
    disengageDynamicOverlayPositioning() {
      this.intersectionObserver.unobserve(this.overlayWrapper), this.resizeObserver.unobserve(document.body), this.scrollListeningContainer.removeEventListener("scroll", this.debouncedCalculateOffset);
    }
    /**
     * Destroys dynamic overlay positioning by:
     * 1. Disconnecting intersection observer
     * 2. Disconnecting resize observer
     * 3. Removing scroll event listener from scrollListeningContainer
     * This method is intended for use when disconnecting component.
     */
    destroyDynamicOverlayPositioning() {
      this.intersectionObserver.disconnect(), this.resizeObserver.disconnect(), this.scrollListeningContainer.removeEventListener("scroll", this.debouncedCalculateOffset);
    }
    /**
     * Adds event listener to the document to close the overlay when clicked outside
     */
    showTooltip() {
      setTimeout(() => {
        this.trigger === h.CLICK && document.addEventListener(y.CLICK, this.handleExternalClick);
      }, 100);
    }
    /**
     * Makes the overlay hidden.
     */
    close() {
      this.isOpen = !1, this.trigger === h.CLICK && document.removeEventListener(y.CLICK, this.handleExternalClick);
    }
    /** Closes the popover when the key pressed is the escape key. */
    closeOnEscape(e) {
      e.key === B.ESCAPE && this.close();
    }
    /**
     * @event {BeaconEvents} beacon-events-close - emits when the overlay is closed with the close() method.
     */
    emitClose() {
      R(this, S.CLOSE, !!this.onBeaconClose && this.onBeaconClose());
    }
    /**
     * @event {BeaconEvents} beacon-events-open - emits when the overlay is closed with the open() method.
     */
    emitOpen() {
      R(this, S.OPEN, !!this.onBeaconOpen && this.onBeaconOpen());
    }
    /**
     * Lit lifecycle hook to handle changing of properties
     */
    updated(e) {
      j(e, "isOpen") && (this.isOpen ? (this.open(), this.emitOpen()) : (this.close(), this.emitClose()));
    }
    overlayPrerender() {
      this.isOpen && this.open(), this.externalClickNode.addEventListener(y.KEYDOWN, this.handleKeydown);
    }
    overlayPostrender() {
      this.calculateOffset();
    }
    overlayDestroy() {
      this.destroyDynamicOverlayPositioning(), this.externalClickNode.removeEventListener(y.KEYDOWN, this.handleKeydown), this.externalClickNode.removeEventListener(y.CLICK, this.handleExternalClick);
    }
    /**
     * Render template: slotted element
     */
    renderSlot() {
      return this.trigger === h.HOVER ? a`<slot @mouseover=${this.open} @mouseout=${this.close}></slot>` : this.trigger === h.CLICK ? a`<slot @click=${this.toggleClick}></slot>` : a`<slot></slot>`;
    }
    /**
     * Render template: overlay content
     */
    renderOverlayContent() {
      return a`<p>${this.content}</p>`;
    }
    /**
     * Render template: overlay content skeleton
     */
    renderContentWrapper() {
      return a`<div class="tooltip-content" aria-live="${this.isOpen ? "polite" : "off"}">${this.renderOverlayContent()}</div>`;
    }
    /**
     * Render template: arrow
     * @todo align the arrow implementation with the navigation popover arrow
     */
    renderArrow() {
      return a`<span class="overlay-arrow ${this.alignment}" aria-hidden="true"></span>`;
    }
    /**
     * Render template: entire overlay skeleton
     */
    renderOverlayWrapper() {
      return this.style.setProperty("--left-offset", `${this.leftOffset}px`), this.style.setProperty("--top-offset", `${this.topOffset}px`), a`<div
          id="${this.overlayName}"
          role="tooltip"
          aria-hidden="${this.isOpen ? "false" : "true"}"
          class="overlay-wrapper ${this.direction}"
        >
          ${this.renderArrow()} ${this.renderContentWrapper()}
        </div>`;
    }
    /**
     * Render template: overlay and target
     */
    render() {
      return a`${this.trigger === h.MANUAL ? k : a`<div class="overlay-target" aria-describedBy="${this.overlayName}">${this.renderSlot()}</div>`}
        ${this.renderOverlayWrapper()}`;
    }
  };
  s([
    p()
  ], i.prototype, "orientation", 2), s([
    p()
  ], i.prototype, "trigger", 2), s([
    p({ type: Boolean, reflect: !0, attribute: "is-open" })
  ], i.prototype, "isOpen", 2), s([
    p()
  ], i.prototype, "content", 2), s([
    p({ type: Function })
  ], i.prototype, "onBeaconClose", 2), s([
    p({ type: Function })
  ], i.prototype, "onBeaconOpen", 2), s([
    f()
  ], i.prototype, "alignment", 2), s([
    f()
  ], i.prototype, "direction", 2), s([
    f()
  ], i.prototype, "topOffset", 2), s([
    f()
  ], i.prototype, "leftOffset", 2), s([
    f()
  ], i.prototype, "RTL", 2), s([
    $("div#tooltip")
  ], i.prototype, "overlayEl", 2), s([
    I(".overlay-wrapper")
  ], i.prototype, "overlayWrapper", 2), s([
    P
  ], i.prototype, "overlayPrerender", 1), s([
    x
  ], i.prototype, "overlayPostrender", 1), s([
    N
  ], i.prototype, "overlayDestroy", 1), i = s([
    D("Overlay")
  ], i);
  class o extends i {
    constructor() {
      super(...arguments), this.open = t && !t.disableDebounceOpen ? E(async () => {
        this.calculateOffset(), this.engageDynamicOverlayPositioning(), this.activeElement = document.activeElement, await this.updateComplete, this.isOpen = !0, this.showTooltip();
      }, 100) : async () => {
        this.calculateOffset(), this.engageDynamicOverlayPositioning(), this.activeElement = document.activeElement, await this.updateComplete, this.isOpen = !0, this.showTooltip();
      };
    }
    /**
     * Handle close and return focus to active element.
     * Also removes listener and observer logic when overlay closed for better performance.
     */
    close() {
      super.close(), this.disengageDynamicOverlayPositioning(), this.focusOnActiveElement();
    }
    /**
     * Handle dark mode theming in action zone
     */
    setActionZoneDarkMode() {
      this.slottedActionzone && this.slottedActionzone.length && this.slottedActionzone.forEach((r) => {
        r.classList.contains("beacon-on-dark") || r.classList.add("beacon-on-dark");
      });
    }
    /**
     * Focuses on the previously active element
     */
    focusOnActiveElement() {
      var r;
      (r = this.activeElement) == null || r.focus();
    }
    /**
     * Render template: close icon button
     */
    renderCloseButton() {
      return A`<${this.getScopedTag("beacon-icon-button")}
                variant="tertiary"
                label="Close Button"
                class="beacon-popover-close-button beacon-on-dark"
                @beacon-event-click="${this.close}"
                >
                <svg slot="icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M18.4697 19.5303C18.7626 19.8232 19.2374 19.8232 19.5303 19.5303C19.8232 19.2374 19.8232 18.7626 19.5303 18.4697L13.0607 12L19.5303 5.53033C19.8232 5.23744 19.8232 4.76256 19.5303 4.46967C19.2374 4.17678 18.7626 4.17678 18.4697 4.46967L12 10.9393L5.53033 4.46967C5.23744 4.17678 4.76256 4.17678 4.46967 4.46967C4.17678 4.76256 4.17678 5.23744 4.46967 5.53033L10.9393 12L4.46967 18.4697C4.17678 18.7626 4.17678 19.2374 4.46967 19.5303C4.76256 19.8232 5.23744 19.8232 5.53033 19.5303L12 13.0607L18.4697 19.5303Z"/>
                </svg>
                </${this.getScopedTag("beacon-icon-button")}>
                `;
    }
    /**
     * Render template: adjusts content wrapper
     */
    renderContentWrapper() {
      return a`<div class="beacon-popover-surface">
          ${this.renderCloseButton()}
          <div class="beacon-popover-zones-wrapper" aria-live="${this.isOpen ? "polite" : "off"}">${this.renderOverlayContent()}</div>
        </div>`;
    }
    /**
     * Render template: slot with only click event
     */
    renderSlot() {
      return a`<slot @click=${this.toggleClick}></slot>`;
    }
  }
  return s([
    $("div#overlay")
  ], o.prototype, "overlayEl", 2), s([
    f()
  ], o.prototype, "activeElement", 2), s([
    z({ flatten: !0, slot: "actionzone" })
  ], o.prototype, "slottedActionzone", 2), t && t.interactive ? o : i;
};
export {
  l as A,
  n as D,
  U as O,
  h as T,
  K as a,
  j as i
};
